//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'

export default {

    name: 'ProfileProductBox',

    mixins: [ProfileData],

    props: {
        product: {
        },
    },

    methods: {
        openModal(id) {
            this.$bus.$emit('profile/openModalDetail', 'product', id)
        }
    },

}

